import { ref, computed } from 'vue'

// Глобальное состояние sidebar
const sidebarOpen = ref<boolean>(() => {
  const saved = localStorage.getItem('sidebar-open')
  return saved ? saved === 'true' : true // По умолчанию открыт
})

export function useSidebar() {
  const toggleSidebar = () => {
    sidebarOpen.value = !sidebarOpen.value
    localStorage.setItem('sidebar-open', sidebarOpen.value.toString())
  }

  const setSidebarOpen = (open: boolean) => {
    sidebarOpen.value = open
    localStorage.setItem('sidebar-open', open.toString())
  }

  const sidebarWidth = computed(() => {
    return sidebarOpen.value ? 'w-64' : 'w-16'
  })

  const mainContentPadding = computed(() => {
    return sidebarOpen.value ? 'lg:pl-64' : 'lg:pl-16'
  })

  return {
    sidebarOpen: computed(() => sidebarOpen.value),
    toggleSidebar,
    setSidebarOpen,
    sidebarWidth,
    mainContentPadding,
  }
}
